/*
Reference Atoms Figma > Colors page for all available colors

Link: https://www.figma.com/file/75QVRcDcsp80ch033WZ7oH/Atoms?node-id=2%3A2
*/

export enum COLORS {
  black = '#000000',
  neutral = '#70787C',
  light = '#D2D5D6',
  smoke = '#F8F8F8',
  white = '#FFFFFF',
  teal = '#5DB4BC',
  gray = '#EAEAEA',
  modernBlue = '#122EF4',
  chargedUpPurple = '#8028EA',
  energeticPink = '#EB4D97',
  brightYellow = '#F7CF4E',
  hintOfTeal = '#EFF7F8',
  hintOfBlue = '#D8DDEC',
  hintOfGray = '#D8D9D9',
  solidTealGradient = 'linear-gradient(270deg, #5DB4BC 0%, #4D529D 99.34%)',
  opacentTealGradient = 'linear-gradient(270deg, rgba(93, 180, 188, 0.8) 0%, rgba(7, 75, 154, 0.8) 99.34%);',
  backgroundOverlay = 'rgba(0, 0, 0, 0.3)',
  border = '#D2D5D6',
  transparent = 'transparent',
}
